import { setupSwiper } from "../utils/swiper-setup";

document.addEventListener("DOMContentLoaded", () => {
  // LOGO GRID MODULES
  const logoGridModules = document.querySelectorAll(
    ".component__logo-grid.layout__slider .swiper",
  );
  logoGridModules.forEach((module) => {
    let id = module.getAttribute("id");
    setupSwiper(id!, {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 48,
      speed: 5000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      allowTouchMove: false,
    });
  });

  // IMAGE MODULES
  const imageModules = document.querySelectorAll(
    ".component__media.media--image .swiper",
  );
  imageModules.forEach((module) => {
    let id = module.getAttribute("id");
    let thisSwiper = setupSwiper(id!, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 24,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: parseInt(
            module.getAttribute("data-slidesPerView") || "3",
            10,
          ),
        },
      },
      navigation: {
        nextEl: "#" + id + "-next",
        prevEl: "#" + id + "-prev",
      },
      pagination: {
        el: "#" + id + "-pagination",
        clickable: true,
      },
    });
  });

  // INTERNAL LINKS MODULES (slider)
  const internalLinksModules = document.querySelectorAll(
    ".component__internal-links:not(.style--grid) .swiper",
  );
  internalLinksModules.forEach((module) => {
    let id = module.getAttribute("id");
    setupSwiper(id!, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
      pagination: {
        el: "#" + id + "-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: "#" + id + "-next",
        prevEl: "#" + id + "-prev",
      },
    });
  });

  // INTERNAL LINKS MODULES (grid — swiper on mobile, CSS grid at desktop)
  const internalLinksGridModules = document.querySelectorAll(
    ".component__internal-links.style--grid .swiper",
  );
  internalLinksGridModules.forEach((module) => {
    let id = module.getAttribute("id");
    setupSwiper(id!, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          enabled: false,
        },
      },
      pagination: {
        el: "#" + id + "-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: "#" + id + "-next",
        prevEl: "#" + id + "-prev",
      },
    });
  });

  // LATEST NEWS MODULES
  const latestNewsModules = document.querySelectorAll(
    ".component__latest-news .swiper",
  );
  latestNewsModules.forEach((module) => {
    let id = module.getAttribute("id");
    setupSwiper(id!, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
      pagination: {
        el: "#" + id + "-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: "#" + id + "-next",
        prevEl: "#" + id + "-prev",
      },
    });
  });
});
